import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";

function ExpirationTimer({ expiration, fontColor = "#5e5e5e" }) {
  const { t } = useTranslation("common");
  const [timeLeft, setTimeLeft] = useState("");

  useEffect(() => {
    const updateTimer = () => {
      const now = new Date();
      const expiry = new Date(expiration);
      const diffMs = expiry - now;

      if (diffMs <= 0) {
        setTimeLeft(t("expired"));
        return;
      }

      const hours = Math.floor(diffMs / (1000 * 60 * 60));
      const minutes = Math.floor((diffMs % (1000 * 60 * 60)) / (1000 * 60));

      setTimeLeft(t("hoursMinutes", { hours, minutes }));
    };

    updateTimer(); // run immediately once
    const interval = setInterval(updateTimer, 60 * 1000); // update every minute

    return () => clearInterval(interval);
  }, [expiration, t]);

  return (
    <div style={{ color: fontColor }}>
      <span>{t("timeLeft")}:</span> {timeLeft}
    </div>
  );
}

export default ExpirationTimer;
